import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class NativeFeaturesConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getEnabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.isEnabled, false);
	}

	getNativeNavigationEnabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.nativeNavigationEnabled, false);
	}

	getTitleEnabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.titleEnabled, false);
	}

	getBetsToolbarDisabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.betsToolbarDisabled, false);
	}

	getHeaderToolbarDisabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.headerToolbarDisabled, false);
	}

	getNativeBetslipEnabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.nativeBetslipEnabled, false);
	}

	getNativeBetBuilderEnabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.nativeBetBuilderEnabled, false);
	}

	getNativeErrorMessagesEnabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.nativeErrorMessagesEnabled, false);
	}

	getGlobalFooterEnabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.globalFooterEnabled, false);
	}

	getBetShareEnabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.betShareEnabled, true);
	}

	getSimplifiedUserFlowEnabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.simplifiedUserFlowEnabled, false);
	}

	getBetslipAutoCloseDisabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.betslipAutoCloseDisabled, false);
	}

	getQuickBetslipDisabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.quickBetslipDisabled, false);
	}

	getBetShareShareLinkEnabled(): boolean {
		return this.configService.get((config) => config.core.nativeFeatures?.betShareShareLinkEnabled, false);
	}
}
